<template>
  <el-alert
    v-if="message"
    :title="message"
    type="warning"
    effect="dark"
    show-icon
    @close="close"
  />
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'

export default defineComponent({
  name: 'MessageAlertDefault',
  setup: () => {
    const userStore = useUserStore()
    const message = computed(() => {
      return userStore.showSystemMessage ? userStore.systemMessage : ''
    })

    const close = () => {
      userStore.HideMessage()
    }

    return { message, close }
  }
})
</script>
